import React, { useState, useEffect } from "react";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import droneImg from "../Assets/Images/Dashboard/drone-img.png";
import robitcsImg from "../Assets/Images/Dashboard/robotics-img.png";

const Curriculum = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [selectedGrade, setSelectedGrade] = useState("6th");
  const [pdfFile, setPdfFile] = useState(null);
  const [selectedSection, setSelectedSection] = useState(
    localStorage.getItem("selectedSection") || "Robotics"
  );

  const syllabusUrls = {
    Drone: {
      "6th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/Standard+6th.pdf",
      "7th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/Standard+7th.pdf",
      "8th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/_Standard+-+8th+.pdf",
      "9th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/_Standard+-+9th+.pdf",
    },
    Robotics: {
      "6th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/ROBOTICS+ACTIVITIES+FOR+THE+STUDENTS-+6TH+STD+(1).pdf",
      "7th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/ROBOTICS+ACTIVITIES+FOR+THE+STUDENTS-+7TH+STD+(1).pdf",
      "8th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/ROBOTICS+ACTIVITIES+FOR+THE+STUDENTS-+8TH+STD+(1).pdf",
      "9th":
        "https://phn1tech2.s3.ap-south-1.amazonaws.com/Syllabus/ROBOTICS+ACTIVITIES+FOR+THE+STUDENTS-+9TH+STD+(1).pdf",
    },
  };

  useEffect(() => {
    setIsLoading(true);
    setPdfFile(syllabusUrls[selectedSection][selectedGrade]);
    setIsLoading(false);
  }, [selectedGrade, selectedSection]);

  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
  };

  const handleSectionClick = (section) => {
    setSelectedSection(section);
    localStorage.setItem("selectedSection", section);
  };

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            <p className="admin_title">Syllabus</p>
            <div className="row">
              <div className="col-lg-4">
                <div className=" dropdown mt-3 d-flex justify-content-center">
                  <label
                    htmlFor="grade-select"
                    className="form-label mt-2 me-2"
                  >
                    Select Grade:
                  </label>
                  <div>
                    <select
                      id="grade-select"
                      className="form-select"
                      style={{
                        border: "none",
                        boxShadow: "0px 4px 34px 0px #b6c1c757",
                        borderRadius: "8px",
                      }}
                      value={selectedGrade}
                      onChange={handleGradeChange}
                    >
                      <option value="" disabled>
                        -- Select Grade --
                      </option>
                      <option value="6th">6th Grade</option>
                      <option value="7th">7th Grade</option>
                      <option value="8th">8th Grade</option>
                      <option value="9th">9th Grade</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 ">
                <div className="choose_section">
                  <div className="d-flex justify-content-center">
                    <p
                      className={
                        selectedSection === "Robotics"
                          ? "sidebar_links py-1 my-1 active"
                          : "sidebar_links py-1 my-1"
                      }
                      onClick={() => handleSectionClick("Robotics")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={robitcsImg} alt="robitcsImg" width={40} />{" "}
                      Robotics
                    </p>
                    <p
                      className={
                        selectedSection === "Drone"
                          ? "sidebar_links py-1 my-1 active"
                          : "sidebar_links py-1 my-1"
                      }
                      onClick={() => handleSectionClick("Drone")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={droneImg} alt="droneImg" width={40} /> Drone
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <div
                className="pdf-viewer mt-4 "
                style={{
                  // border: "1px solid rgba(0, 0, 0, 0.3)",
                  border: "none",
                  height: "750px",
                }}
              >
                {pdfFile ? (
                  <iframe
                    title="Syllabus"
                    src={pdfFile}
                    width="100%"
                    height="750px"
                    style={
                      {
                        // border: "1px solid rgba(0, 0, 0, 0.3)",
                      }
                    }
                  ></iframe>
                ) : (
                  <>
                    {" "}
                    <p className="progressMainTitle text-center">
                      No data available
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Curriculum;
